var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarWashHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_268",
    "data-name": "Group 268",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 63.283,
    viewBox: "0 0 81 63.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 81,
    height: 63.283,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268-2",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M5.759,220.58a5.362,5.362,0,0,1-2.235-.473,5.771,5.771,0,0,1-1.837-1.31,6.277,6.277,0,0,1,0-8.592A5.807,5.807,0,0,1,3.524,208.9a5.362,5.362,0,0,1,2.235-.473,5.355,5.355,0,0,1,2.62.657,5.905,5.905,0,0,1,1.984,1.754l-2.243,1.205a3.3,3.3,0,0,0-1.046-.8,3.014,3.014,0,0,0-2.574-.025,3.281,3.281,0,0,0-1.038.766,3.6,3.6,0,0,0-.7,1.134,3.95,3.95,0,0,0,0,2.771,3.6,3.6,0,0,0,.7,1.134,3.332,3.332,0,0,0,1.038.77,2.973,2.973,0,0,0,2.574-.025,3.292,3.292,0,0,0,1.046-.816l2.243,1.222a5.983,5.983,0,0,1-1.984,1.749,5.327,5.327,0,0,1-2.62.661",
    transform: "translate(0 -168.379)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M62.54,210.692H65.37l4.252,11.719H66.96l-.67-1.842H61.619l-.669,1.842H58.288Zm0,7.366H65.37l-1.423-3.884Z",
    transform: "translate(-47.088 -170.209)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M124.245,222.411V210.692h4.771a3.225,3.225,0,0,1,1.741.486,3.549,3.549,0,0,1,1.235,1.3,3.617,3.617,0,0,1,.456,1.8,3.849,3.849,0,0,1-.251,1.4,3.536,3.536,0,0,1-.716,1.147,3.621,3.621,0,0,1-1.092.8l2.779,4.788h-2.9l-2.645-4.554h-.871v4.554Zm2.511-7.065h1.959a1.131,1.131,0,0,0,.611-.171,1.311,1.311,0,0,0,.444-.456,1.261,1.261,0,0,0,0-1.255,1.313,1.313,0,0,0-.444-.456,1.137,1.137,0,0,0-.611-.172h-1.959Z",
    transform: "translate(-100.372 -170.209)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M183.039,222.411l-3-11.719h2.595l1.808,7.1,1.808-7.1h2.31l1.808,7.1,1.808-7.1h2.595l-2.98,11.719h-2.829l-1.557-6.077-1.54,6.077Z",
    transform: "translate(-145.449 -170.21)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M260.531,210.692h2.829l4.252,11.719h-2.662l-.67-1.842H259.61l-.669,1.842h-2.662Zm0,7.366h2.829l-1.423-3.884Z",
    transform: "translate(-207.037 -170.209)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M322.333,220.58a5.726,5.726,0,0,1-1.892-.314,4.757,4.757,0,0,1-1.582-.9,3.4,3.4,0,0,1-.979-1.41l2.36-.871a1.062,1.062,0,0,0,.372.469,2.4,2.4,0,0,0,.733.373,3.133,3.133,0,0,0,.988.147,2.991,2.991,0,0,0,.946-.147,1.908,1.908,0,0,0,.72-.406.8.8,0,0,0,.276-.6.714.714,0,0,0-.289-.582,2.227,2.227,0,0,0-.737-.368,5.994,5.994,0,0,0-.917-.205,9.347,9.347,0,0,1-2.281-.607,3.854,3.854,0,0,1-1.591-1.168,2.979,2.979,0,0,1-.582-1.891,3.109,3.109,0,0,1,.619-1.921,4.134,4.134,0,0,1,1.636-1.285,5.266,5.266,0,0,1,2.2-.46,5.763,5.763,0,0,1,1.9.314,4.71,4.71,0,0,1,1.586.908,3.354,3.354,0,0,1,.971,1.423l-2.36.854a1.037,1.037,0,0,0-.372-.465,2.4,2.4,0,0,0-.732-.364,3.228,3.228,0,0,0-.988-.142,2.725,2.725,0,0,0-.929.142,2.039,2.039,0,0,0-.728.41.779.779,0,0,0-.285.586.824.824,0,0,0,.268.674,1.612,1.612,0,0,0,.707.314q.439.092.967.167a8.382,8.382,0,0,1,2.218.628,4.3,4.3,0,0,1,1.624,1.205,2.819,2.819,0,0,1,.611,1.833,3.122,3.122,0,0,1-.615,1.921,4.108,4.108,0,0,1-1.628,1.285,5.278,5.278,0,0,1-2.21.461",
    transform: "translate(-256.802 -168.379)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M380.478,210.692h2.512v11.719h-2.512v-5.022h-4.152v5.022h-2.511V210.692h2.511v4.185h4.152Z",
    transform: "translate(-301.99 -170.21)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M152.444,280.566h1.882l3.408,9.375H156l-.6-1.661h-4.018l-.6,1.661h-1.734Zm-.469,6.08h2.819l-1.413-3.864Z",
    transform: "translate(-120.405 -226.658)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M201.564,289.94v-9.375h3.348a2.586,2.586,0,0,1,1.383.381,2.787,2.787,0,0,1,.981,1.025,2.829,2.829,0,0,1,.362,1.413,2.794,2.794,0,0,1-.372,1.43,2.842,2.842,0,0,1-.995,1.018,2.572,2.572,0,0,1-1.359.378H203.2v3.73Zm1.634-5.364h1.54a1.206,1.206,0,0,0,.636-.174,1.3,1.3,0,0,0,.459-.469,1.283,1.283,0,0,0,.171-.656,1.3,1.3,0,0,0-.629-1.131,1.206,1.206,0,0,0-.636-.174H203.2Z",
    transform: "translate(-162.835 -226.657)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M240.911,289.94v-9.375h3.348a2.586,2.586,0,0,1,1.383.381,2.787,2.787,0,0,1,.981,1.025,2.829,2.829,0,0,1,.362,1.413,2.793,2.793,0,0,1-.372,1.43,2.842,2.842,0,0,1-.994,1.018,2.572,2.572,0,0,1-1.359.378h-1.714v3.73Zm1.634-5.364h1.54a1.206,1.206,0,0,0,.636-.174,1.3,1.3,0,0,0,.459-.469,1.283,1.283,0,0,0,.171-.656,1.3,1.3,0,0,0-.629-1.131,1.206,1.206,0,0,0-.636-.174h-1.54Z",
    transform: "translate(-194.622 -226.657)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M120.04,17.867a2.7,2.7,0,0,1-1.016-2.11,2.357,2.357,0,0,1,2.354-2.354h1.875a2.225,2.225,0,0,1,1.513.594l.881-1.322a6.38,6.38,0,0,1,5.334-2.834h10.272a6.381,6.381,0,0,1,5.335,2.835l.879,1.32a2.225,2.225,0,0,1,1.512-.594h1.875a2.357,2.357,0,0,1,2.354,2.354,2.7,2.7,0,0,1-1.015,2.11,6.27,6.27,0,0,1,1.523,2.271,17.758,17.758,0,1,0-35.2,0,6.269,6.269,0,0,1,1.522-2.271",
    transform: "translate(-95.617 0.001)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M182.454,166.92c-.034-.023-.068-.045-.1-.07l-1.207-.9a.667.667,0,0,0-.4-.135H166.485a.66.66,0,0,0-.4.132l-1.222.913c-.03.023-.062.043-.093.064v.2a17.781,17.781,0,0,0,17.678,0Z",
    transform: "translate(-133.116 -133.951)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M140.763,68.817a6.919,6.919,0,0,0,2.243.373h11.838a6.919,6.919,0,0,0,2.243-.373l6.55-2.237a5.418,5.418,0,0,0-2.792-1.11l-2.729-4.095a4.863,4.863,0,0,0-4.055-2.149H143.789a4.863,4.863,0,0,0-4.055,2.149l-2.729,4.095a5.419,5.419,0,0,0-2.792,1.11Z",
    transform: "translate(-108.425 -47.846)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M156.146,99.811,149.3,102.15a7.5,7.5,0,0,1-2.429.4H135.032a7.5,7.5,0,0,1-2.429-.4l-6.847-2.339a5.644,5.644,0,0,0-1.414,4.068v7.585a1.053,1.053,0,0,0,1.054,1.054h5.256a1.044,1.044,0,0,0,.631-.211l1.216-.909a2.194,2.194,0,0,1,1.322-.442h14.258a2.2,2.2,0,0,1,1.324.442l1.213.909a1.049,1.049,0,0,0,.631.211h5.259a1.055,1.055,0,0,0,1.054-1.054v-7.585a5.644,5.644,0,0,0-1.414-4.068",
    transform: "translate(-100.451 -80.633)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M129.3,171.26a.619.619,0,0,0,.619.619h4.04a.619.619,0,0,0,.619-.619v-1.1H129.3Z",
    transform: "translate(-104.459 -137.468)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M264.782,171.26a.619.619,0,0,0,.619.619h4.04a.619.619,0,0,0,.619-.619v-1.1h-5.279Z",
    transform: "translate(-213.906 -137.468)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M184.712,27.115l.433,1.171,1.171.433a.047.047,0,0,1,0,.089l-1.171.433-.433,1.171a.047.047,0,0,1-.089,0l-.433-1.171-1.171-.433a.047.047,0,0,1,0-.089l1.171-.433.433-1.171a.047.047,0,0,1,.089,0",
    transform: "translate(-147.828 -21.88)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M158.332,68.225l1.857-2.787a3.923,3.923,0,0,1,3.283-1.737h9.874a3.922,3.922,0,0,1,3.283,1.736l1.858,2.788Z",
    transform: "translate(-127.91 -51.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M136.042,116.491l-3.716-.176a.712.712,0,0,1-.679-.712v-1a1.01,1.01,0,0,1,1.192-.994l4.582.838a.446.446,0,0,1,.279.7l-.619.843a1.219,1.219,0,0,1-1.04.5",
    transform: "translate(-106.353 -91.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M139.541,153.5h-2.548a.417.417,0,0,1-.374-.6l.393-.8a.417.417,0,0,1,.374-.234h2.531a.417.417,0,0,1,.378.594l-.376.8a.417.417,0,0,1-.378.24",
    transform: "translate(-110.334 -122.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M165.894,125.164a.44.44,0,0,1-.453-.533l.315-1.18a3.159,3.159,0,0,1,2.865-2.309c.074,0,.147-.006.223-.006h10.575c.074,0,.149,0,.223.006a3.164,3.164,0,0,1,2.865,2.309l.312,1.18a.44.44,0,0,1-.45.533Z",
    transform: "translate(-133.642 -97.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M259.581,116.491l3.716-.176a.712.712,0,0,0,.679-.712v-1a1.01,1.01,0,0,0-1.192-.994l-4.582.838a.446.446,0,0,0-.279.7l.619.843a1.219,1.219,0,0,0,1.04.5",
    transform: "translate(-208.294 -91.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M266.1,153.5h2.548a.417.417,0,0,0,.374-.6l-.393-.8a.417.417,0,0,0-.375-.234h-2.531a.417.417,0,0,0-.378.594l.376.8a.417.417,0,0,0,.378.24",
    transform: "translate(-214.328 -122.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M166.737,88.857l.357.964.964.357a.039.039,0,0,1,0,.073l-.964.357-.357.964a.039.039,0,0,1-.073,0l-.357-.964-.964-.357a.039.039,0,0,1,0-.073l.964-.357.357-.964a.039.039,0,0,1,.073,0",
    transform: "translate(-133.554 -71.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M133.071,79.749h-2.078a1.17,1.17,0,0,1-1.17-1.17.817.817,0,0,1,.817-.817h1.875a.7.7,0,0,1,.7.7v1.145a.143.143,0,0,1-.143.143",
    transform: "translate(-104.879 -62.821)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M274.23,79.749h2.078a1.17,1.17,0,0,0,1.17-1.17.817.817,0,0,0-.817-.817h-1.875a.7.7,0,0,0-.7.7v1.145a.143.143,0,0,0,.143.143",
    transform: "translate(-221.424 -62.821)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M219.4,13.1l.688,1.86,1.86.688a.075.075,0,0,1,0,.141l-1.86.688-.688,1.86a.075.075,0,0,1-.141,0l-.688-1.86-1.86-.688a.075.075,0,0,1,0-.141l1.86-.688.688-1.86a.075.075,0,0,1,.141,0",
    transform: "translate(-175.033 -10.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M262.373,35.669l.481,1.3,1.3.482a.053.053,0,0,1,0,.1l-1.3.482-.481,1.3a.053.053,0,0,1-.1,0l-.482-1.3-1.3-.482a.053.053,0,0,1,0-.1l1.3-.482.482-1.3a.053.053,0,0,1,.1,0",
    transform: "translate(-210.412 -28.788)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWashHeaderLogo);
export default __webpack_public_path__ + "static/media/CarWash-HeaderLogo.c561a661361845907e078169957a72d5.svg";
export { ForwardRef as ReactComponent };